import {Box, Button, Card, CardHeader, Grid, ImageListItem, LinearProgress, Paper, Typography} from "@mui/material";
import "./style.css";
import React from "react";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import {styled} from '@mui/material/styles';
import {useSelector} from "react-redux";


const Item = styled(Paper)(({theme}) => ({
    padding: theme.spacing(2),
    textAlign: 'center',
    boxShadow: '0px 5px 20px 0 rgba(48, 61, 78, 0.08)',
    border: '2px solid #F5F5F5',
    borderRadius: '16px !important'
}));
export const ProgressSection = () => {

    const {statisticsReducer} = useSelector(s => s);

    const {
        confirmation_call_count = 0,
        box_delivery_7_days_prior_count = 0,
        after_delivery_call_count = 0,
        after_ld_pickup_calls_count = 0,
        job_delivery_with_balance_count = 0,
        total_tasks_count = 0,
        completed_tasks_count = 0,
        progress_percent = 0
    } = statisticsReducer;

    function LinearProgressWithLabel() {
        return (
            <>
                <Box sx={{px: 3, display: 'flex', alignItems: 'center', mb: 2}}>
                    <Typography variant='div' component='div' fontWeight={500} fontSize="20px" color={'#828A94'} mr={2}>
                        Total tasks
                        <Typography variant='span' component='span' color={'#19212B'} sx={{mx: 2}}>
                            {total_tasks_count || 0}
                        </Typography>
                    </Typography>
                    <Typography variant='div' component='div' fontWeight={500} fontSize="20px" color={'#828A94'}>
                        Completed
                        <Typography variant='span' component='span' color={'#19212B'} sx={{mx: 2}}>
                            {completed_tasks_count || 0}
                        </Typography>
                    </Typography>
                </Box>
                <Box sx={{display: 'flex', alignItems: 'center', position: 'relative', mx: 3}}>
                    <Box sx={{width: '100%',}}>
                        <LinearProgress
                            value={progress_percent || 0}
                            variant="determinate"
                            sx={{
                                height: '3px',
                                overflow: 'unset',
                                overflowX: 'clip',
                                position: 'relative',
                                background: '#EAEBED',
                                '& .MuiLinearProgress-bar': {
                                    background: '#1CC99F',
                                    boxShadow: '0 2px 10px 2px rgba(145, 255, 228, 1)'
                                }
                            }}
                        />
                    </Box>
                    <Box sx={{
                        position: 'absolute',
                        left: progress_percent <= 95 ? `calc(${progress_percent}% + 1%)` : `calc(${progress_percent}% - 3%)`
                    }}>
                        <Typography variant="div" color={'#1CC99F'} fontSize={'20px'}>
                            {`${Math.round(progress_percent)}%`}
                        </Typography>
                    </Box>
                </Box>
            </>
        );
    }

    return (
        <>
            <Box sx={{
                pb: 3,
                boxShadow: '0px 5px 20px 0 rgba(48, 61, 78, 0.08)',
                border: '2px solid #F5F5F5',
                borderRadius: '16px !important',
                m: 2
            }}>
                <Card sx={{boxShadow: 'none', borderRadius: '16px', px: 3, pt: 2, pb: 1}}>
                    <CardHeader
                        sx={{px: 0}}
                        action={
                            <Button sx={{mr: 1}} className="completedTask" variant="outlined"
                                    endIcon={<KeyboardArrowRightIcon/>}>
                                View completed tasks
                            </Button>
                        }
                        title={
                            <Typography variant='div' component='div' fontWeight={600} fontSize="30px"
                                        lineHeight={'35px'}>Today’s progress</Typography>
                        }
                    />
                </Card>
                <LinearProgressWithLabel/>
            </Box>
            <Box sx={{pb: 3, m: 2}}>
                <Grid container spacing={2}>
                    <Grid item xs={12 / 5}>
                        <Item>
                            <ImageListItem sx={{'& img': {width: 'auto !important', mx: 'auto', mb: 2}}}>
                                <img
                                    src="./assets/images/ConfirmationCall.png"
                                    alt="Logo"
                                />
                            </ImageListItem>
                            <Typography variant='div' component='div' fontWeight={600} fontSize="30px"
                                        lineHeight={'37px'} color={'#19212B'}
                                        mb={2}>{confirmation_call_count || 0}</Typography>
                            <Typography variant='div' component='div' fontWeight={500} fontSize="16px"
                                        lineHeight={'22px'} color={'#828A94'}>Confirmation calls</Typography>
                        </Item>
                    </Grid>
                    <Grid item xs={12 / 5}>
                        <Item>
                            <ImageListItem sx={{'& img': {width: 'auto !important', mx: 'auto', mb: 2}}}>
                                <img
                                    src="/assets/images/BoxDelivery.png"
                                    alt="Logo"
                                />
                            </ImageListItem>
                            <Typography
                                variant='div'
                                component='div'
                                fontWeight={600}
                                fontSize="30px"
                                lineHeight={'37px'}
                                color={'#19212B'}
                                mb={2}
                            >
                                {box_delivery_7_days_prior_count || 0}
                            </Typography>
                            <Typography variant='div' component='div' fontWeight={500} fontSize="16px"
                                        lineHeight={'22px'} color={'#828A94'}>Box delivery 7 days prior</Typography>
                        </Item>
                    </Grid>
                    <Grid item xs={12 / 5}>
                        <Item>
                            <ImageListItem sx={{'& img': {width: 'auto !important', mx: 'auto', mb: 2}}}>
                                <img
                                    src="/assets/images/AfterDelivery.png"
                                    alt="Logo"
                                />
                            </ImageListItem>
                            <Typography
                                variant='div' component='div' fontWeight={600} fontSize="30px"
                                lineHeight={'37px'} color={'#19212B'} mb={2}
                            >
                                {after_delivery_call_count || 0}
                            </Typography>
                            <Typography variant='div' component='div' fontWeight={500} fontSize="16px"
                                        lineHeight={'22px'} color={'#828A94'}>After delivery call</Typography>
                        </Item>
                    </Grid>
                    <Grid item xs={12 / 5}>
                        <Item>
                            <ImageListItem sx={{'& img': {width: 'auto !important', mx: 'auto', mb: 2}}}>
                                <img
                                    src="/assets/images/AfterPickup.png"
                                    alt="Logo"
                                />
                            </ImageListItem>
                            <Typography variant='div' component='div' fontWeight={600} fontSize="30px"
                                        lineHeight={'37px'} color={'#19212B'} mb={2}>{after_ld_pickup_calls_count || 0}</Typography>
                            <Typography variant='div' component='div' fontWeight={500} fontSize="16px"
                                        lineHeight={'22px'} color={'#828A94'}>After LD pickup calls </Typography>
                        </Item>
                    </Grid>
                    <Grid item xs={12 / 5}>
                        <Item>
                            <ImageListItem sx={{'& img': {width: 'auto !important', mx: 'auto', mb: 2}}}>
                                <img
                                    src="/assets/images/JobDelivery.png"
                                    alt="Logo"
                                />
                            </ImageListItem>
                            <Typography variant='div' component='div' fontWeight={600} fontSize="30px"
                                        lineHeight={'37px'} color={'#19212B'} mb={2}>{job_delivery_with_balance_count || 0}</Typography>
                            <Typography variant='div' component='div' fontWeight={500} fontSize="16px"
                                        lineHeight={'22px'} color={'#828A94'}>Job delivery with balance</Typography>
                        </Item>
                    </Grid>
                </Grid>
            </Box>
        </>
    )
}



